module.exports = __webpack_public_path__ + "assets/retina_ErectPerpDetailed.f0ff805962c0ffe961e28a4830781c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ErectPerpDetailed.png
// module id = 667
// module chunks = 0